// This JavaScript file is created by Cision for our newsfeed.
// This is the first version of this file so far.
// This should be combined with relese.html 

var cision = cision || {};
cision.websolution = cision.websolution || {};

cision.websolution.liverss = !cision.websolution.settings.liverss ? {} : function ($) {

    var settings = cision.websolution.settings.general,
        accessKey = cision.websolution.settings.liveRss.accessKey,
        releases = null;

    var renderListing = function (options) {

        if (options) {
            $.extend(settings, options);
        }
        if (!accessKey) {
            console.log("You must provide your live-rss access key.");
            return;
        }

        if ($.isArray( releases)) {
            processReleases(options);
            return;
        }

        retrieveReleases(function(){
            processReleases(options);
        });
        
    };

    function processReleases(options){
        pager.releasesList = releases;
        releases.each(function() {
                    var $el = $("<div class='item'>");
                    $el = $el.append($.parseHTML($(this).find("description").text()));
                    $el.appendTo("#release-list");
                    pager.paragraphs.push($el);
                    return $el;
                });

        pager.showPage(1);
    }

    function retrieveReleases(callback){
        if ($.isArray( releases)) {
            callback(releases);
            return;
        }

        $.ajax({
                url: settings.proxyHandler,
                type: 'GET',
                dataType: 'xml',
                data: {
                    url: settings.serviceEndpointRss + '?key=' + accessKey
                }
            })
            .done(function(xml) {
                releases = $(xml).find("item");
                callback(releases);

            })
            .fail(function() {
                console.log('Could not retrieve releases data');
            });

            releases = [];
    }

    return {
        renderListing: renderListing 
    };

} (jQuery);
